import React from 'react';
import styled from 'styled-components';

const Card = styled.div`
  background: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 12px;
  padding: 20px 24px;
  transition: border-color 0.2s;

  &:hover {
    border-color: ${({ theme }) => theme.primary};
  }
`;

const Top = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 12px;
`;

const Logo = styled.img`
  width: 44px;
  height: 44px;
  border-radius: 8px;
  object-fit: contain;
  background: #1a1a2e;
  flex-shrink: 0;
  padding: 4px;
`;

const Meta = styled.div`
  flex: 1;
`;

const SchoolName = styled.h3`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
  margin-bottom: 3px;
`;

const Degree = styled.p`
  font-size: 13.5px;
  font-weight: 500;
  color: ${({ theme }) => theme.primary};
  margin-bottom: 2px;
`;

const DateRange = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.text_secondary};
`;

const Grade = styled.p`
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.text_secondary};
  margin-bottom: 8px;

  strong {
    color: ${({ theme }) => theme.text_primary};
  }
`;

const Description = styled.p`
  font-size: 13.5px;
  line-height: 1.7;
  color: ${({ theme }) => theme.text_secondary};
`;

const EducationCard = ({ education }) => {
  return (
    <Card>
      <Top>
        {education.img && <Logo src={education.img} alt={education.school} />}
        <Meta>
          <SchoolName>{education.school}</SchoolName>
          <Degree>{education.degree}</Degree>
          <DateRange>{education.date}</DateRange>
        </Meta>
      </Top>
      {education.grade && (
        <Grade><strong>Grade:</strong> {education.grade}</Grade>
      )}
      {education.desc && <Description>{education.desc}</Description>}
    </Card>
  );
};

export default EducationCard;
